__turbopack_context__.v({
  "className": "seriffont_ce08eaec-module__hCqvHq__className",
  "variable": "seriffont_ce08eaec-module__hCqvHq__variable",
});
